module.exports = __webpack_public_path__ + "images/emoji/green_heart.6878b47b339d10680173.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/green_heart.png
// module id = FGat
// module chunks = 1